/* eslint-disable import/first, import/newline-after-import */

import 'components/util/ad-container/ad-container';
import 'components/global/ads/ads';

import EezyStimulusApplication from 'packs/eezy-stimulus';

import AdsController from 'controllers/ads-controller';
EezyStimulusApplication.register('ads-main', AdsController);

import StickyAdContainerController from 'components/util/ad-container/sticky-ad-container-controller';
EezyStimulusApplication.register('sticky-ad-container', StickyAdContainerController);
